// extracted by mini-css-extract-plugin
export default {"button":"Button_button__xoFkt","contained":"Button_contained__NrDFG","outlined":"Button_outlined__B0-Ru","fullWidth":"Button_fullWidth__7sHdD","fa-beat":"Button_fa-beat__cTX84"};